// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dm9SyZvpL8MyK1 {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-surface, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.Dm9SyZvpL8MyK1:focus-within {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .Dm9SyZvpL8MyK1:focus-within {
  outline-color: -webkit-focus-ring-color;
}
.Dm9SyZvpL8MyK1:focus-within .mac.firefox {
  outline-color: AccentColor;
}
.Dm9SyZvpL8MyK1 > a {
  display: block;
  height: 100%;
  text-decoration: none;
}
.DixFsoZpaUkdLa {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.Dm9SyZvpL8MyK1:hover .nu1exix5zZb9dt {
  background-color: hsla(0, 0%, 0%, 0.25);
}
.Dm9SyZvpL8MyK1:hover .SzliHsDO_R43nR {
  background-color: hsla(0, 0%, 0%, 0.4);
}
.Oyv4uPfpaB4_Yz {
  height: 72px;
  background-color: var(--ds-skeleton, #091e420f);
  background-position: center center;
  background-size: cover;
}
.gWl3Xe9ruADN19 {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  gap: var(--ds-space-100, 8px);
}
.lIWTZoJKzh08st {
  display: block;
  position: absolute;
  top: var(--ds-space-100, 8px);
  left: var(--ds-space-100, 8px);
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  padding: var(--ds-space-025, 2px);
  border-radius: var(--ds-border-radius-circle, 50%);
  background-color: hsla(0, 0%, 0%, 0.25);
}
.lIWTZoJKzh08st::before {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  border-radius: var(--ds-border-radius-circle, 50%);
  background-color: var(--ds-background-information-bold, #0c66e4);
}
.cLjyiYsr7DPxNE {
  margin: var(--ds-space-0, 0) var(--ds-space-100, 8px) var(--ds-space-100, 8px);
  padding: var(--ds-space-025, 2px) var(--ds-space-050, 4px);
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--ds-background-neutral-bold, #44546f);
  color: var(--ds-text-inverse, #ffffff);
  font-size: 11px;
  font-weight: var(--ds-font-weight-bold, 700);
  line-height: 16px;
  text-transform: uppercase;
}
.A8LqoOPy7X6XII {
  --ds-icon: #ffffff;
  display: flex;
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin: var(--ds-space-100, 8px) var(--ds-space-100, 8px) var(--ds-space-0, 0);
  overflow: hidden;
  transform: translateX(150%);
  transition: transform 0.2s ease-in-out 0.2s;
  border-radius: var(--ds-border-radius-200, 6px);
  background-color: hsla(0, 0%, 0%, 0.25);
}
.A8LqoOPy7X6XII.l3pMOz7c_jJzkT {
  transform: translateX(0);
}
.A8LqoOPy7X6XII button {
  width: 100%;
  height: 100%;
  border-radius: var(--ds-border-radius-200, 6px);
}
.Dm9SyZvpL8MyK1:hover .A8LqoOPy7X6XII,
.Dm9SyZvpL8MyK1:focus-within .A8LqoOPy7X6XII {
  transform: translateX(0);
}
.pIQ5_g4p0XJopD {
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  flex: 1;
  width: 100%;
}
.GOPk_J9hMP7py5 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: var(--ds-space-100, 8px);
  overflow: hidden;
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-regular, 400);
  line-height: 20px;
  word-wrap: break-word;
}
`, ""]);
// Exports
export var boardTile = `Dm9SyZvpL8MyK1`;
export var boardDetails = `DixFsoZpaUkdLa`;
export var dark = `nu1exix5zZb9dt`;
export var light = `SzliHsDO_R43nR`;
export var background = `Oyv4uPfpaB4_Yz`;
export var badges = `gWl3Xe9ruADN19`;
export var activityIndicator = `lIWTZoJKzh08st`;
export var templateLozenge = `cLjyiYsr7DPxNE`;
export var starContainer = `A8LqoOPy7X6XII`;
export var isStarred = `l3pMOz7c_jJzkT`;
export var boardNameContainer = `pIQ5_g4p0XJopD`;
export var boardName = `GOPk_J9hMP7py5`;
export default ___CSS_LOADER_EXPORT___;
